var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"position-relative"},[_c('span',{staticClass:"playhera-icon mx-4 cursor-pointer",on:{"click":function($event){$event.preventDefault();return (function ($event) { return _vm.openSharingMenu({
          event: $event,
          type: _vm.account._type,
          text: ((_vm.$filters.displayName(_vm.account)) + " " + (_vm.$t(
            '_web_' + _vm.account._type,
            _vm.account._type
          )) + " on "),
          id: _vm.account._id,
          vanityId: _vm.account.vanityId,
        }); })($event)}}},[_c('Icon',{attrs:{"name":"share"}})],1),_c('router-link',{attrs:{"to":{
      name: _vm.$routerNames.EDIT,
      params: Object.assign({}, _vm.account.params,
        _vm.$route.params),
    }}},[_c('Icon',{attrs:{"name":"settings-outline"}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }